import {RoutesPaths} from "../../routes/routes-paths/routes-paths";
import {RoutesParts} from "../../constants/routes-parts";

export const GoalsRoutesPaths = {
  CREATE_INTRO_PATH: RoutesPaths.GOALS + RoutesParts.CREATE,
  CREATE_FORM_PATH: RoutesPaths.GOALS + RoutesParts.CREATE_FORM,
  OVERVIEW: RoutesPaths.GOALS + RoutesParts.OVERVIEW,
  DELETE_CONFIRMATION: RoutesPaths.GOALS + RoutesParts.DELETE_CONFIRMATION
}
